/** Color formatting shared by the asset viewers. */

function toHex2(value: number): string {
  return value.toString(16).padStart(2, "0");
}

/** Formats an `[r, g, b]` triple (0-255 each) as an uppercase `#RRGGBB` string. */
export function rgbToHex([r, g, b]: readonly [number, number, number]): string {
  return `#${toHex2(r)}${toHex2(g)}${toHex2(b)}`.toUpperCase();
}
